const initialState = {
    medias: [],
    selectedMiscellaneous: null,
};

const mediaReducer = (state = initialState, action) => {
    switch (action.type) {
    case "GET_MEDIA":
        return {
            ...state,
            medias: action.payload,
        };
    case "SET_SELECTED_MISCELLANEOUS":
        return {
            ...state,
            selectedMiscellaneous: action.payload,
        };
    default:
        return state;
    }
};

export default mediaReducer;
